import { inject } from '@angular/core'
import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http'
import { Router } from '@angular/router'

import { tap } from 'rxjs/operators'

import { environment } from '@env'

import { ToastType } from '../components/toast/toast.models'
import { ToastService } from '../components/toast/toast.service'

const redirectToLogin = (router: Router) => {
  sessionStorage.clear()
  void router.navigate([environment.REDIRECT_LOGIN_URL])
}

const showErrorToast = (error: HttpErrorResponse, toasterService: ToastService) => {
  const errorResponse = error.error || {}
  const errorResponseString = JSON.stringify(errorResponse)
  const errorCode = errorResponse.code ? `- ${errorResponse.code}` : ''

  toasterService.showToast({
    type: ToastType.Error,
    message: errorResponse.message || (errorResponseString !== '{}' ? errorResponseString : null),
    devInfo: `${error.status} ${errorCode}`,
  })
}

const handleError = (error: unknown, router: Router, toasterService: ToastService) => {
  if (!(error instanceof HttpErrorResponse) || !error.status) {
    return
  }

  if (error.status === 401) {
    redirectToLogin(router)
  } else {
    showErrorToast(error, toasterService)
  }
}

export const alertsInterceptor: HttpInterceptorFn = (request, next) => {
  const toasterService = inject(ToastService)
  const router = inject(Router)

  return next(request).pipe(tap({ error: (error) => handleError(error, router, toasterService) }))
}
